import axios from "axios";
import { UserStore } from "stores";
import type {
  FromsRespons,
  FromsAnswersReq,
  FileUploadRespons,
} from "./types/forms";
import type { RequestedForm } from "helpers/types";

export const getRequestedForms = async () =>
  axios
    .get<RequestedForm[]>("/form/requested")
    .then(({ data }) => {
      UserStore.setRequestedForms(data);
      return data;
    })
    .catch((err) => console.log("form request err", err));

export const getFormById = async (id: number) =>
  axios.get<FromsRespons>(`/form/requested-form/${id}`);

export const sendForm = async (formId: number, answers: FromsAnswersReq) =>
  axios.post(`/form/requested-form/${formId}`, answers);

export const uploadFile = async (file: any) =>
  axios.post<FileUploadRespons>(
    `/file/upload`,
    { file },
    { headers: { "Content-Type": "multipart/form-data" } }
  );
